import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { getFilteredInvoices, getPages, getPageTitle, getPaginatedInvoices, getUnpaidInvoiceTotal } from '../reducer';
import { clearSelectedInvoiceNumbers, onChangeFilters, onChangePage, onFapiaoCancelled, resetFilters, updateSelections } from '../actions';
import Invoices from './Invoices';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    invoice = _ref.invoice,
    user = _ref.user;
  var match = _ref2.match;
  return {
    allowsFapiaoProcessingAfterPayment: application.currentLocalization.allowsFapiaoProcessingAfterPayment,
    currency: user.currency,
    displayingUnpaidInvoices: match.params.status === 'unpaid',
    filteredInvoices: getFilteredInvoices({
      invoice: invoice,
      user: user,
      match: match
    }),
    filters: invoice.filters,
    invoices: invoice.invoices,
    pageTitle: getPageTitle({
      match: match
    }),
    pages: getPages({
      invoice: invoice,
      user: user,
      match: match
    }),
    paginatedInvoices: getPaginatedInvoices({
      invoice: invoice,
      user: user,
      match: match
    }),
    pagination: invoice.pagination,
    selectedInvoiceNumbers: invoice.selectedInvoiceNumbers,
    status: invoice.status,
    unpaidInvoices: user.unpaidInvoices,
    unpaidInvoicetotal: getUnpaidInvoiceTotal({
      invoice: invoice,
      user: user,
      match: match
    }),
    user: user
  };
};
var mapDispatchToProps = {
  clearSelectedInvoiceNumbers: clearSelectedInvoiceNumbers,
  onChangeFilters: onChangeFilters,
  onChangePage: onChangePage,
  onFapiaoCancelled: onFapiaoCancelled,
  resetFilters: resetFilters,
  updateSelections: updateSelections
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Invoices));